import { createMMKV } from 'react-native-mmkv';

import { subDays, isValid } from 'date-fns';

/**
 * Integrates with local storage via MMKV to store when the customer dismissed the flex entry point.
 * The flex entry point should only be shown if the customer has not dismissed it in the last 30 days.
 */
export function checkIfHasRecentlyDismissedFlexEntryPoint() {
  const dismissedFlexCheckDate = FLEX_STORAGE.getString(DISMISSED_FLEX_ENTRY_POINT_DATE);

  if (!dismissedFlexCheckDate || !isValid(new Date(dismissedFlexCheckDate))) {
    return false;
  }

  try {
    return new Date(dismissedFlexCheckDate) > subDays(new Date(), 30);
  } catch {
    return false;
  }
}

/**
 * Stores the date in which the customer dismissed the flex entry point.
 */
export function storeDismissedFlexEntryPointDate() {
  FLEX_STORAGE.set(DISMISSED_FLEX_ENTRY_POINT_DATE, new Date().toISOString());
}

// ─── Constants ───────────────────────────────────────────────────────────────

const FLEX_STORAGE = createMMKV({ id: 'sg.flex' });
const DISMISSED_FLEX_ENTRY_POINT_DATE = 'dismissed-flex-entry-point-date';
